import React, { Component } from 'react';
import { Icon } from 'antd';
import Slider from 'react-slick';

export default class Testimonials extends Component {
  constructor(props) {
	super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.state = {
		slideIndex: 0,
		updateCount: 0
	};
  }
  next(e) {
	  e.preventDefault();
    this.slider.slickNext();
  }
  previous(e) {
	  e.preventDefault();
	  this.slider.slickPrev();
  }
  render(){
	  var {updateCount,slideIndex} = this.state
	var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
		slidesToScroll: 1,
		afterChange: () =>
        this.setState({ updateCount: updateCount + 1 }),
      beforeChange: (current, next) => this.setState({ slideIndex: next })
      };
      return(
          <div>
            <div className="testimonial-styletwo">
				<div className="container">
					<div className="row">
						<div className="col-md-12  col-xs-12 ">
							<div className="wrapper">
								<div className="theme-title">
									<h2>Client Feedback</h2>
								</div>

								<div style={{position:"relative"}} id="testimonial-carousel-two" className="carousel slide" data-ride="carousel" data-interval="500000">
									
									<ol className="carousel-indicators">
										<li data-target="#testimonial-carousel-two" data-slide-to="0" className="active tran3s" title="Jenna Simpson"><img src="img/home/10.jpg" alt=""/></li>
										<li data-target="#testimonial-carousel-two" data-slide-to="1" className="tran3s" title="Bello Fuad"><img src="https://res.cloudinary.com/afrikal/image/upload/q_auto:best/w_1500,h_1500,c_crop,g_face/w_600/v1577517015/IMG_5591_r4gvjw.jpg" alt=""/></li>
										<li data-target="#testimonial-carousel-two" data-slide-to="2" className="tran3s" title="Natasha Jackson"><img src="img/home/11.jpg" alt=""/></li>
										<li data-target="#testimonial-carousel-two" data-slide-to="3" className="tran3s" title="Habeeb abdulrahman"><img src="https://res.cloudinary.com/afrikal/image/upload/q_auto:best/w_1500,h_1500,c_crop/w_600/v1577284487/IMG_2248_xnde64.jpg" alt=""/></li>
									</ol>

								  	<div className="main-wrapper">
								  		<div className="shadow"></div>
								  		
									  	<div className="carousel-inner">
											  <Slider ref={c => (this.slider = c)} autoplay {...settings}>
										    <div className="item active">
										    	<h3>If you're a developer, you owe it to yourself to follow @orsity. Short, instructional videos on the technologies we use.</h3>
											    <p>We are dedicated to respecting your time. This means that orsity courses get to the point and deliver knowledge that you can use today. </p>
											    <div className="clearfix">
											    	<img src="img/home/10.jpg" alt="" className="float-left"/>
											    	<div className="name float-left">
											    		<h6>Web Developer</h6>
											    		<i>Derek Jensen</i>
											    	</div>
											    </div>
										    </div>

										    <div className="item">
										    	<h3>
												Recruiters saw my Professional Certificate. on my LinkedIn profile. During the interview, they told me they were impressed with the skills I learned. I got the job!
												</h3>
											    <p>Orsity is a group of working web development professionals and open source contributors that provide you with concise, information dense video courses on the best tools in the industry.</p>
											    <div className="clearfix">
											    	<img src="img/home/11.jpg" alt="" className="float-left"/>
											    	<div className="name float-left">
														<h6>UI/UX Developer</h6>
											    		<i>Natasha Jackson</i>
														
											    	</div>
											    </div>
										    </div>

										    <div className="item ">
										    	<h3>Learn the best JavaScript tools and frameworks from industry pros.</h3>
											    <p>You won't find boring 8 hour courses on orsity, instead you'll find a wealth of bite-sized courses that pack more information in a fraction of the time.</p>
											    <div className="clearfix">
											    	<img src="https://res.cloudinary.com/afrikal/image/upload/q_auto:best/w_1500,h_1500,c_crop/w_600/v1577284487/IMG_2248_xnde64.jpg" alt="" className="float-left"/>
											    	<div className="name float-left">
													<h6>Software Engineer</h6>
											    	<i>Habeeb Abdulrahman</i>
											    	</div>
											    </div>
										    </div>

										    <div className="item">
										    	<h3>
												I started at stage zero. With Orsity I was able to start learning online and eventually build up enough knowledge and skills to transition into a well-paying career
												</h3>
											    <p>Ready to get started? Orsity has many free community resource courses for you to start learning today. Create your free account and choose something to learn..</p>
											    <div className="clearfix">
											    	<img src="img/home/13.jpg" alt="" className="float-left"/>
											    	<div className="name float-left">
											    		<h6>Frontend Developer</h6>
											    		<i>David Thompson</i>
											    	</div>
											    </div>
										    </div>

										    <div className="item">
										    	<h3>Thank you Orsity! your courses are the BEST! </h3>
											    <p>Coding skills have never been more in-demand. Learn everything you need to take your career to the next level.</p>
											    <div className="clearfix">
												
											    	<img src="https://res.cloudinary.com/afrikal/image/upload/q_auto:best/w_1500,h_1500,c_crop,g_face/w_600/v1577517015/IMG_5591_r4gvjw.jpg" alt="" className="float-left"/>
											    	<div className="name float-left">
											    		<h6>Fullstack JS Developer</h6>
											    		<i>Bello Ajibola Fuad</i>
											    	</div>
											    </div>
										    </div>
											</Slider>
									  	</div> 

									  	
										<a className="left carousel-control" href="#"  onClick={this.previous} data-slide="prev">
										   <i className="flaticon-arrows"></i>
										    <span className="sr-only">Previous</span>
										</a>
										<a className="right carousel-control" href="#" onClick={this.next} data-slide="next" >
										    <i className="flaticon-arrows"></i>
										    <span className="sr-only">Next</span>
										</a>
								  	</div> 
								</div>
							</div>
						</div>
						{/* <div className="col-md-5 col-xs-12">
							<div className="partner-logo">
								<div className="theme-title">
									<h2>Our Partners</h2>
								</div>
								<div className="row">
									<div className="col-xs-6">
										<div className="single-logo"><img src="img/logo/p-5.png" alt=""/></div>
									</div>
									<div className="col-xs-6">
										<div className="single-logo"><img src="img/logo/p-6.png" alt=""/></div>
									</div>
									<div className="col-xs-6">
										<div className="single-logo"><img src="img/logo/p-7.png" alt=""/></div>
									</div>
									<div className="col-xs-6">
										<div className="single-logo"><img src="img/logo/p-8.png" alt=""/></div>
									</div>
								</div> 
							</div>
						</div> */}
					</div> 
				</div>
			</div> 
          </div>
      )
  }
}
